module.exports = __webpack_public_path__ + "img/20240925095712.cbd9d3df.jpg";